import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import { postBankAccount } from '../../../../actions';
import { BANK_ACCOUNT_PATH } from '../../../../config/paths';
import BankAccountForm from './BankAccountForm';

const NewBankAccount = ({ breadcrumbs, dispatchPostBankAccount }) => {
  const onSubmit = (formValues) => {
    const newFormValues = {
      ...formValues,
      bankId: formValues.bankId ? formValues.bankId.value : null,
      businessId: formValues.businessId ? formValues.businessId.value : null,
      currency: formValues.currency ? formValues.currency.value : null,
      active: true,
    };
    dispatchPostBankAccount(newFormValues);
  };

  const content = <BankAccountForm onSubmit={onSubmit} />;
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Cuenta Bancaria"
      subtitle="Crear nueva cuenta bancaria."
      content={content}
    />
  );
};

const mapDispatchToProps = {
  dispatchPostBankAccount: postBankAccount,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Cuentas Bancarias',
      href: BANK_ACCOUNT_PATH,
    },
    {
      text: 'Nueva Cuenta Bancaria',
      href: '',
    },
  ],
});

NewBankAccount.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostBankAccount: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewBankAccount);
